import { PUBLISHING_TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';

// This shows up as "Marketing task properties" in the filter editor
// https://app.hubspotqa.com/framework-data-explorer/103594261/0-50?schemaSearch=0-50
const PublishingTask = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: PUBLISHING_TASK_TYPE_ID,
  referenceObjectType: 'PUBLISHING_TASK_PROPERTIES'
});
export default PublishingTask;